import { cn } from '@/utils';
import { useNodes } from '@xyflow/react';
import type { FC } from 'react';
import { memo, useMemo } from 'react';
import { Panel as NodePanel } from '../nodes';
import { Node } from '../types';
import { useStore } from '../store';
const Panel: FC = () => {
  const nodes = useNodes<Node>();
  const selectedNode = useMemo(
    () => nodes.find((node) => node.data._selected),
    [nodes],
  );
  const eventFromContext = useStore((s) => s.eventFromContext);

  eventFromContext?.useSubscription(async ({ type, payload }) => {
    if (type === 'CLICK_PUBLISH' && !selectedNode) {
      console.log(
        'eventFromContext emit CLICK_PUBLISH event, but not show panel',
      );
      payload?.resolve?.(true);
    }
  });

  return (
    <div
      tabIndex={-1}
      className={cn('absolute inset-y-4 right-0 flex z-10 outline-none')}
    >
      {!!selectedNode && <NodePanel node={selectedNode} />}
    </div>
  );
};

export default memo(Panel);
